import axios from 'axios';

import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;

if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function book(data) {
  return axios.post(`${baseURL}/api/v1/bookings`, { data });
}

export function cancelBooking(bookingId) {
  return axios.delete(`${baseURL}/api/v1/bookings/${bookingId}`);
}

export function delayBooking(id, bookingId, roomId) {
  return axios.put(`${baseURL}/api/v1/bookings/${id}/state`, { bookingId, roomId, state: 4 });
}

export function blockPreBooking(bookingId) {
  return axios.put(`${baseURL}/api/v1/bookings/block/${bookingId}`);
}

export function getMonthAvailabilityByRoom(roomId, month, year, numDays) {
  return axios.get(`${baseURL}/api/v1/bookings/room/${roomId}/month/${month}/year/${year}/${numDays}/false`);
}

export function assignNewDateToBooking(roomId, bookingId, datesFrom, datesTo, newBookingRoomId) {
  return axios.put(`${baseURL}/api/v1/bookings/${bookingId}/dates`, { datesFrom, datesTo, roomId, newBookingRoomId });
}

export function bookings(stateId) {
  return axios.get(`${baseURL}/api/v1/bookings/state/${stateId}`);
}

export function bookingsFiltered(statesId, filters) {
  let query = '';
  for (let i = 0; i < filters.length; i++) {
    if (query.length === 0) query += `${filters[i].label}=${filters[i].value}`;
    else query += `&${filters[i].label}=${filters[i].value}`;
  }
  return axios.get(`${baseURL}/api/v1/bookings/state/filters?${query}`);
}

export function blockedDaysByRoom(roomId) {
  return axios.get(`${baseURL}/api/v1/bookings/blocked/room/${roomId}`);
}

export function manualBooking(roomId, data) {
  return axios.post(`${baseURL}/api/v1/bookings/blocked/room/${roomId}`, { data });
}

export function setManualInvoiceId(bookingId, invoiceId) {
  return axios.put(`${baseURL}/api/v1/bookings/invoice/${bookingId}`, { invoiceId });
}



// WEBPACK FOOTER //
// ./src/services/bookings.js